import { Category } from "@/types/category";
import React from "react";
import Image from "next/image";

const SingleItem = ({ item }: { item: Category }) => {
  return (
    <a
      href={item.url}
      title={item.title}
      className="group flex flex-col items-center"
      itemScope
      itemType="https://schema.org/Product"
      >
      <div className="max-w-[130px] w-full bg-[#F2F3F8] h-32.5 rounded-full flex items-center justify-center mb-4">
        <Image
          src={item.img.src}
          alt={item.img.alt}
          width={item.img.width}
          height={item.img.height}
          itemProp="image"
        />
      </div>

      <div className="flex justify-center">
        <h3 itemProp="name" className="inline-block font-medium text-center text-dark bg-gradient-to-r from-blue to-blue bg-[length:0px_1px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_1px] group-hover:text-purple">
          {item.name}
        </h3>
      </div>
      <meta itemProp="description" content={item.title} />
      <meta itemProp="url" content={item.url} />
    </a>
  );
};

export default SingleItem;
